const dragDropUtils = {
  // convert drag and drop entry to file selected
  async toFileSelected(nodeInfo) {
    const readAllEntries = async(dirReader) => {
      // continuously call readEntries() until entries.length is 0
      const results = []
      let entries = []
      do {
        entries = await new Promise((resolve, reject) => {
          dirReader.readEntries(resolve, reject)
        })
        results.push(...entries)
      } while (entries.length > 0)

      return results
    }
    const getFileWithTimeout = async (entry, timeoutMs = 100) => {
      const file = Promise.race([
        new Promise((resolve, reject) => entry.file(resolve, reject)),
        new Promise((_, reject) => {
            setTimeout(() => reject("Read file timeout"), timeoutMs)
        })
      ])

      return file
    }

    const item = nodeInfo.entry
    const dirReader = item.createReader()
    const currentPath = nodeInfo.path ? `${nodeInfo.path}/${nodeInfo.name}` : nodeInfo.name
    const entries = await readAllEntries(dirReader)
    const fileInfos = []
    let containEmptyFolder = false

    for (const entry of entries) {
      if (entry.isFile) {
        try {
          const file = await getFileWithTimeout(entry)
          const fileInfo = {
            content: file,
            relativePath: `${currentPath}/${file.name}`,
            size: file.size,
          }

          fileInfos.push(fileInfo)
        } catch (error) {
          console.error('Error:', error, 'File path: ', entry.fullPath)
          continue
        }
      } else if (entry.isDirectory) {
        const fileSelect = await this.toFileSelected({
          entry,
          name: entry.name,
          path: currentPath,
        })
        const nestedFiles = fileSelect.fileInfos

        if (fileSelect.containEmptyFolder) {
          containEmptyFolder = true
        }

        if (nestedFiles.length > 0) {
          fileInfos.push(...nestedFiles)
        }
      }
    }

    if (fileInfos.length === 0) {
      containEmptyFolder = true
    }

    const result = {
      fileInfos: fileInfos,
      containEmptyFolder,
    }

    return result
  }
}

export default dragDropUtils
